import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["carrier", "number", "url"]
  static values = { couriers: { type: Object, default: {} } }

  fillUrl() {
    const num = this.numberTarget.value.trim()
    const urlField = this.urlTarget

    // Only auto-fill if URL field is empty or was previously auto-filled
    if (urlField.value && !urlField.dataset.autofilled) return

    if (num) {
      const template = this._getTemplate()
      urlField.value = template.replace("{number}", num)
      urlField.dataset.autofilled = "true"
    } else {
      urlField.value = ""
      delete urlField.dataset.autofilled
    }
  }

  carrierChanged() {
    // Re-fill URL when carrier changes (if number already entered)
    if (this.numberTarget.value.trim()) {
      // Reset autofilled flag so fillUrl will update
      if (this.urlTarget.dataset.autofilled) {
        delete this.urlTarget.dataset.autofilled
      }
      this.fillUrl()
    }
  }

  _getTemplate() {
    if (this.hasCarrierTarget) {
      const carrier = this.carrierTarget.value.trim()
      const templates = this.couriersValue
      if (carrier && templates[carrier]) {
        return templates[carrier]
      }
    }
    // Default fallback
    return "https://t.17track.net/en#nums={number}"
  }
}
